module.exports = __webpack_public_path__ + "img/market-data-card.c850bef.jpg";